export const snakeCaseToHumanReadable = (
  key: string | undefined | null
): string => {
  if (!key) return "";

  if (!key.replaceAll) return key;
  return key.replaceAll("_", " ");
};
